import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useI18n } from "../../../../../contexts";
const FormContentBlockerFieldGeneralDescription = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Description"),
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "description",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Input.TextArea, {
                    autoSize: {
                        minRows: 3
                    }
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("You can give your visitors further explanations why a content has been blocked or, for example, how they can contact you alternatively instead of agreeing to load the contact form. The description is displayed only in visual content blockers.")
            })
        ]
    });
};
export { FormContentBlockerFieldGeneralDescription };
